import { Spin } from 'antd';

const CustomLoadingSpin = () => {
  return (
    <div className="loading-container" style={{ textAlign: 'center', padding: '250px' }}>
      <Spin size="large" className="custom-spin" />
    </div>
  );
};

export default CustomLoadingSpin;
